import {
	AllocationMethodEnum,
	AssignmentFranchiseTypeEnum,
	AssignmentSettingUsedEnum,
	AssignmentStatusEnum,
	FormError,
	RangeAgeEnum,
} from '@/constant';
import { IWorkerAssignmentDetailStore } from '@/stores';
import { injectedFieldServerError, NOOP } from '@/utils';

import { SortOrder } from 'antd/es/table/interface';

import { FormikProps } from 'formik';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import * as Yup from 'yup';

import { WorkHistoryLayer } from '..';
import { ColumnTypes } from '../common/table/type';
import { DefineAssignmentType } from './define-assignment.type';

export const initialValues = {};

export const initialValuesFilter = {
	fullName: '',
	assignmentPossibility: AssignmentStatusEnum.ASSIGNMENT_POSSIBLE,
};

export const TriggerDefineAssignmentClick = {
	show: NOOP,
};

export const mapPropsToValues = (
	props: DefineAssignmentType,
	{
		assignmentDetail,
		publicFranchiseId,
		programId,
		programStartDate,
		programEndDate,
	}: {
		assignmentDetail: IWorkerAssignmentDetailStore;
		publicFranchiseId: number;
		programId?: string | number | null;
		programStartDate?: string;
		programEndDate?: string;
	}
) => {
	const {
		franchiseId,
		franchiseName,
		districtId,
		startDate,
		endDate,
		applicantIds,
		assignmentfranchiseid,
		isPublicApplicant,
	} = props;

	const isDetail = isNotNilOrEmpty(assignmentfranchiseid);

	return {
		type: AssignmentFranchiseTypeEnum.COMMON,
		...injectedFieldServerError({
			franchiseId: isDetail ? assignmentDetail?.franchiseId : franchiseId || '',
			franchiseName: isDetail
				? assignmentDetail?.franchiseName
				: franchiseName || '',
			districtId: isDetail ? assignmentDetail?.districtId : districtId || '',
			startDate: isDetail
				? assignmentDetail?.startDate
				: startDate || programStartDate || '',
			endDate: isDetail
				? assignmentDetail?.endDate
				: endDate || programEndDate || '',
			assignmentMethod: AllocationMethodEnum.MANUAL_ASSIGNMENT,
		}),

		publicFranchiseId: isDetail
			? assignmentDetail?.publicFranchiseId
			: publicFranchiseId || props.publicFranchiseId || '',
		requestApplicant: isDetail ? assignmentDetail.requestApplicant : 9,
		programId: isDetail ? assignmentDetail.programId : programId || '',
		memo: isDetail ? assignmentDetail.memo : '',

		isUsed: AssignmentSettingUsedEnum.NOT_USED,
		assignSetting: {
			maleRequest: '0',
			maleAgeRange: '' as RangeAgeEnum,
			femaleRequest: '0',
			femaleAgeRange: '' as RangeAgeEnum,
		},

		applicantIds: applicantIds || [],

		isPublicApplicant,

		fromApplicant: isNotNilOrEmpty(applicantIds),

		isDetail,
	};
};

export const validationSchema = Yup.object().shape({
	franchiseId: Yup.string().required(FormError.REQUIRED),
	assignmentMethod: Yup.string().required(FormError.REQUIRED),

	requestApplicant: Yup.number().min(1).required(),
});

export type TValues = ReturnType<typeof mapPropsToValues>;

export type TParamsFilter = typeof initialValuesFilter;

export type MyFormikType = FormikProps<TValues>;

export const rowKey = 'id';

export const getColumns = ({
	isApplicantSelected,
	onSort,
}: {
	isApplicantSelected?: boolean;
	onSort?: (field: string, order?: SortOrder) => void;
} = {}): ColumnTypes => [
	{
		align: 'center',
		title: '읍/면',
		dataIndex: 'districtName',
		key: 'districtName',
	},
	{
		align: 'center',
		title: '성',
		dataIndex: 'firstName',
		key: 'firstName',
	},
	{
		align: 'center',
		title: '이름',
		dataIndex: 'lastName',
		key: 'lastName',
	},
	{
		align: 'center',
		title: '입/출국',
		dataIndex: 'dateEntryAndDeparture',
		key: 'dateEntryAndDeparture',
	},
	{
		align: 'center',
		title: '나이',
		dataIndex: 'age',
		key: 'age',
		sorter: !isApplicantSelected,
	},
	{
		align: 'center',
		title: '성별',
		dataIndex: 'genderName',
		key: 'genderName',
		sorter: !isApplicantSelected,
	},
	{
		align: 'center',
		title: '키/몸무게',
		dataIndex: 'heightPerWeight',
		key: 'heightPerWeight',
	},
	{
		align: 'center',
		title: '근무 이력',
		dataIndex: 'workHistory',
		key: 'workHistory',
		render: (id) => <WorkHistoryLayer id={id} />,
	},
	{
		align: 'center',
		title: '등록일',
		dataIndex: 'registDt',
		key: 'registDt',
		sorter: !isApplicantSelected,
	},
	{
		align: 'center',
		title: '추천자',
		dataIndex: 'recommenderName',
		key: 'recommenderName',
	},
	{
		align: 'center',
		title: '숙소 제공자',
		dataIndex: 'providerName',
		key: 'providerName',
	},
];
